// file path: src/stores/users.slice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserData } from './user.service';
import { FilterColumn, SortColumn } from '../../Types/common.type';

interface UsersState {
  users: UserData[];
  sortByColumns: SortColumn[];
  filterByColumns: FilterColumn[];
  rowsPerPage: number;
  totalRows: number;
  deleteConfirmShow: number;
  processing: boolean;
  currentPage: number;
  searchTerm: string;
}

const initialState: UsersState = {
  users: [],
  sortByColumns: [],
  filterByColumns: [],
  rowsPerPage: 10,
  totalRows: 0,
  deleteConfirmShow: -1,
  processing: false,
  currentPage: 1,
  searchTerm: '',
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<UserData[]>) => {
      state.users = action.payload;
    },
    setSortByColumns: (state, action: PayloadAction<SortColumn[]>) => {
      state.sortByColumns = action.payload;
    },
    setFilterByColumns: (state, action: PayloadAction<FilterColumn[]>) => {
      state.filterByColumns = action.payload;
    },
    setRowsPerPage: (state, action: PayloadAction<number>) => {
      state.rowsPerPage = action.payload;
    },
    setTotalRows: (state, action: PayloadAction<number>) => {
      state.totalRows = action.payload;
    },
    setDeleteConfirmShow: (state, action: PayloadAction<number>) => {
      state.deleteConfirmShow = action.payload;
    },
    setProcessing: (state, action: PayloadAction<boolean>) => {
      state.processing = action.payload;
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    updateUser: (state, action: PayloadAction<{ user: UserData; index: number }>) => {
      state.users[action.payload.index] = action.payload.user;
    },
    deleteUser: (state, action: PayloadAction<number>) => {
      state.users.splice(action.payload, 1);
      state.totalRows = state.totalRows - 1;
    },
    resetUsersState: () => initialState,
  },
});

export const {
  setUsers,
  setSortByColumns,
  setFilterByColumns,
  setRowsPerPage,
  setTotalRows,
  setDeleteConfirmShow,
  setProcessing,
  setCurrentPage,
  setSearchTerm,
  updateUser,
  deleteUser,
  resetUsersState,
} = usersSlice.actions;

export default usersSlice.reducer;
